<mat-form-field class="w-100">
	<mat-label *ngIf="!isRequest">Customer</mat-label>
	<input autocomplete="off" matInput [placeholder]="isRequest ? '' : 'Search for Customer'" [required]="required"
		[formControl]="customer" [matAutocomplete]="customerTypeAhead" />
	<mat-icon matSuffix>search</mat-icon>
	<mat-autocomplete [displayWith]="displayName" (optionSelected)="optionSelected.emit($event.option.value)"
		#customerTypeAhead="matAutocomplete" panelWidth="26em">
		<ng-container *ngIf="multiline">
			<div class="multiline-mat-options" *ngFor="let customer of filteredCustomers$ | async">
				<mat-option [value]="customer">
					{{ displayName(customer) }}
					<div class="option-sub-line" *ngIf="customer.billingEmail">
						{{ customer.billingEmail }}
					</div>
					<div class="option-sub-line">
						{{ customer.address }}
					</div>
				</mat-option>
				<div class="multiline-mat-options__actions" target="_blank">
					<a mat-icon-button target="_blank" [routerLink]="customersFragments.detail(customer.id)">
						<mat-icon interactive>edit</mat-icon>
					</a>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="!multiline">
			<mat-option *ngFor="let customer of filteredCustomers$ | async" [value]="customer">
				{{ displayName(customer) }}
			</mat-option>
		</ng-container>


	</mat-autocomplete>
	<mat-error>Required</mat-error>
	<mat-hint *ngIf="isRequest">{{ customerAddress$ | async }}</mat-hint>
</mat-form-field>